import React, { useRef } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

interface ImageCropProps {
  imageSrc: any;
  field?: any;
  setCropImage?: (cropImage: boolean) => void;
}

export default function ImageCrop({
  imageSrc,
  field,
  setCropImage,
}: ImageCropProps) {
  const cropperRef = useRef<ReactCropperElement>(null);

  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    const canvas = cropper!.getCroppedCanvas();
    if (canvas?.toDataURL()) {
      const mimeType = imageSrc.type === "image/jpg" ? "image/jpeg" : (imageSrc.type || "image/png");
      const base64Data = canvas.toDataURL(mimeType);
      const binaryString = atob(base64Data.split(",")[1]);

      const binaryArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        binaryArray[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([binaryArray], { type: mimeType });
      const file = [new File([blob], imageSrc.name, { type: mimeType })];
      field.onChange(file);
      if (setCropImage) {
        setCropImage(false);
      }
    }
  };

  return (
    <Stack>
      <Cropper
        src={URL.createObjectURL(imageSrc)}
        style={{ height: 200, width: "100%" }}
        initialAspectRatio={16 / 9}
        guides={false}
        ref={cropperRef}
        background={false}
      />
      <Button
        variant="text"
        size="small"
        onClick={() => {
          onCrop();
        }}
      >
        Crop Image
      </Button>
    </Stack>
  );
}
